module.exports = __webpack_public_path__ + "dbb925af2819d0554bd03fb8e1c4ba8c.png";